export const danhMucThuKhac = {
  sections: {
    list: { title: 'Danh mục thu khác' },
    detail: { title: 'Danh mục thu khác' },
  },
  titles: { add: 'Thêm thu khác', edit: 'Sửa danh mục thu khác' },
  columns: {
    code: 'Mã thu',
    summary: 'Tên thu khác',
    note: 'Mô tả',
    loaiThuKhac: 'Loại thu',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    status: 'Trạng thái',
    onOffAction: 'Bật tắt',
  },
  filter: {
    searchPlaceholder: 'Tìm theo mã, tên thu khác...',
    textDetailTitle: 'Bộ lọc chi tiết',
  },
  filters: {
    hintSection: 'Gợi ý',
    hintBody: 'Quản lý các khoản thu bổ sung dùng cho hóa đơn và phiếu trả hàng.',
    statusAll: 'Tất cả',
    loaiThuKhacAll: 'Tất cả',
  },
  loaiThuKhac: {
    CO_DINH: 'Cố định (VND)',
    PHAN_TRAM: 'Phần trăm (%)',
    TUY_CHON: 'Tùy chọn',
  },
  status: {
    dangHoatDong: 'Đang hoạt động',
    ngungHoatDong: 'Tạm ngưng',
  },
  trangThai: {
    DANG_HOAT_DONG: 'Đang hoạt động',
    TAM_NGUNG: 'Tạm ngưng',
  },
  actions: {
    pause: 'Tạm ngưng',
    activate: 'Kích hoạt',
  },
  messages: {
    loadError: 'Không tải được danh sách thu khác.',
    deleteSuccess: 'Đã xóa danh mục thu khác.',
    noData: 'Không có danh mục thu khác.',
    listSummary: 'Tổng {count} mục',
    saveSuccess: 'Đã lưu danh mục thu khác.',
    statusChanged: 'Đã cập nhật trạng thái.',
    selectedCount: 'Đã chọn {count}',
    deleteSelected: 'Xóa đã chọn ({count})',
    bulkDeleteConfirm: 'Xóa {count} danh mục thu khác đã chọn?',
    bulkDeleteSuccess: 'Đã xóa {count} danh mục thu khác',
    bulkDeletePartial: 'Đã xóa {ok}/{total}. {failed} mục không xóa được.',
    bulkDeleteError: 'Xóa hàng loạt thất bại',
    bulkDeleteNoneSelected: 'Chưa chọn danh mục thu khác nào để xóa',
  },
  form: {
    maThuKhac: 'Mã thu',
    maThuKhacPlaceholder: 'Để trống để tự sinh (TK0001…)',
    maThuKhacHint: 'Không nhập thì hệ thống tự sinh mã TK + 4 số.',
    tenThuKhac: 'Tên thu khác',
    loaiThuKhac: 'Loại thu',
    giaTri: 'Giá trị (VND)',
    phanTram: 'Phần trăm (%)',
    moTa: 'Mô tả',
  },
  validation: {
    tenRequired: 'Vui lòng nhập tên thu khác.',
    giaTriRequired: 'Giá trị cố định phải là số không âm.',
    phanTramRequired: 'Phần trăm phải từ 0 đến 100.',
  },
  placeholders: {
    formTitle: 'Danh mục thu khác',
    formBody: '',
  },
  reorder: {
    open: 'Sắp xếp thứ tự',
    title: 'Sắp xếp thứ tự danh mục thu khác',
    hint: 'Dùng nút lên/xuống để đổi thứ tự. Thứ tự này là thứ tự các cột thu khác trên danh sách hóa đơn.',
    move: 'Di chuyển',
    moveUp: 'Lên',
    moveDown: 'Xuống',
    saved: 'Đã cập nhật thứ tự danh mục thu khác',
    saveFailed: 'Cập nhật thứ tự thất bại',
  },
}
